module.exports = __webpack_public_path__ + "img/cxTrends-11.0cc9ee53.png";